/**
 * #120936 — Cầu nối để ghi ngược tham số lên URL từ NGOÀI cây `RouterProvider`.
 *
 * VÌ SAO CẦN: `BranchProvider` bọc NGOÀI `RouterProvider` (`src/index.js`), nên trong
 * `BranchContext` không gọi được `useSearchParams`/`useNavigate` của react-router.
 *
 * VÌ SAO KHÔNG DÙNG THẲNG `window.history.replaceState`: react-router giữ `location` trong
 * state nội bộ của nó. Sửa lịch sử sau lưng router thì `useSearchParams` của các trang vẫn
 * đọc giá trị CŨ, và lần `setSearchParams` kế tiếp của trang sẽ dựng lại query từ bản cũ →
 * **xoá mất `branch_id` vừa ghi**. Đó đúng là loại lỗi "thỉnh thoảng không ăn param" mà mục
 * 4a của khuôn cảnh báo. Đi qua `router.navigate` giữ router và URL luôn khớp nhau.
 */

let router = null;

/** Gọi 1 lần ở `src/index.js` ngay sau `createBrowserRouter`. */
export const registerRouter = (instance) => {
  router = instance;
};

/**
 * Ghi lại chuỗi query của ĐÚNG trang hiện tại bằng `replace` (không `push`).
 * Luật mục 1c-2 của khuôn: đổi bộ lọc không được nhét thêm mục vào lịch sử.
 *
 * @param {string} search - dạng `?a=1` hoặc chuỗi rỗng.
 * @returns {boolean} false nếu router chưa sẵn sàng (trước lần render đầu).
 */
export const replaceSearch = (search) => {
  if (!router || typeof window === 'undefined') return false;
  if (search === window.location.search) return true;

  router.navigate(`${window.location.pathname}${search}${window.location.hash}`, {
    replace: true,
  });
  return true;
};
